import React from 'react';
import styles from './ListingItem.module.css';
import ListingCard from './ListingCard';

const ListingItem = (props) => {
    const {
        title,
        subtitle,
        icon,
        actions,
        onClick,
        className = "",
        children,
        variant = "list",
        iconVariant = "primary",
        level = 2, // Default level for items is 2 (higher than container)
        badges = [], // Array of badge elements to display next to title
        metadata = [], // Array of metadata objects: [{ label, value }]
        description // Optional description text (for richer content)
    } = props;

    if (variant === 'grid') {
        return <ListingCard {...props} />;
    }

    return (
        <div
            className={`${styles.itemWrapper} ${styles[variant]} ${styles[`level-${level}`]} ${className}`}
            onClick={onClick}
            style={{
                cursor: onClick ? 'pointer' : 'default',
                background: `var(--surface-lvl${level})`
            }}
        >
            <div className={styles.mainContent}>
                {icon && <div className={`${styles.icon} ${styles[`icon-${iconVariant}`]}`}>{icon}</div>}

                <div className={styles.content}>
                    <div className={styles.header}>
                        <div className={styles.titleRow}>
                            {title && <h3 className={styles.title}>{title}</h3>}
                            {badges.length > 0 && (
                                <div className={styles.badges}>
                                    {badges.map((badge, index) => (
                                        <React.Fragment key={index}>{badge}</React.Fragment>
                                    ))}
                                </div>
                            )}
                        </div>
                        {actions && (
                            <div className={styles.actions} onClick={(e) => e.stopPropagation()}>
                                {actions}
                            </div>
                        )}
                    </div>

                    {(subtitle || description) && (
                        <p className={styles.subtitle}>{subtitle || description}</p>
                    )}

                    {children}

                    {metadata.length > 0 && (
                        <div className={styles.metadataGrid}>
                            {metadata.map((item, index) => (
                                <div key={index} className={styles.metadataItem}>
                                    <div className={styles.metadataLabel}>{item.label}</div>
                                    <div className={styles.metadataValue}>{item.value}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ListingItem;
